import { AppService } from '@/bundles/App/models/AppService';
import { generateParams } from '@/utils/helpers';

export default class CompanyServiceV2 extends AppService {
  async getCompanyNames (params: { keyword: string }): Promise<string[]> {
    try {
      const arrayParams = Object.entries(params).map(([name, value]) => {
        return { name, value };
      });
      const paramsString = generateParams(arrayParams);

      return await this.transport.get(`company/get-names${paramsString}`);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }
}
